/**
 * ReportsHarvestInspectionNumberOfContainers
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    numberOfContainers?: ?number;
}

export class ReportsHarvestInspectionNumberOfContainers extends React.PureComponent<Props> {
    render() {
        const { numberOfContainers } = this.props;
        if (!numberOfContainers && numberOfContainers !== 0) return null;
        return numberOfContainers;
    }
}

const mapStateToProps = createStructuredSelector({
    numberOfContainers: makeSelectReportsHarvestInspectionValue(
        'numberOfContainers'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionNumberOfContainers
);
